import { MoreVert } from "@mui/icons-material";
import { IconButton, TableCell, TableRow } from "@mui/material";
import { useState } from "react";

import { SETTLEMENT_STYLES } from "../../style/styles";

import {
  formatAdditionalExpenseCurrency,
  getDeductionTypeLabel,
} from "./helpers/functions";
import OtherLiensBalanceDropdownMenu from "./OtherLiensBalanceDropdownMenu";

export default function OtherLiensBalanceListItem({
  data,
  deductionTypeDisplayMap,
  onEdit,
  onDelete,
  canEdit = false,
  canDelete = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const showActions = canEdit || canDelete;

  return (
    <TableRow hover>
      <TableCell>{data.label || "N/A"}</TableCell>
      <TableCell>{formatAdditionalExpenseCurrency(data.amount)}</TableCell>
      <TableCell>
        {getDeductionTypeLabel(deductionTypeDisplayMap, data.deductionType ?? data.deduction_type) ||
          "N/A"}
      </TableCell>
      {showActions ? (
        <TableCell align="right">
          <div className="flex items-center justify-end">
            <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)}>
              <MoreVert sx={SETTLEMENT_STYLES.moreIcon} />
            </IconButton>
          </div>
          <OtherLiensBalanceDropdownMenu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={() => setAnchorEl(null)}
            onEdit={() => {
              onEdit(data);
              setAnchorEl(null);
            }}
            onDelete={() => {
              onDelete(data);
              setAnchorEl(null);
            }}
            expenseId={data.pk || data.id}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        </TableCell>
      ) : null}
    </TableRow>
  );
}
